import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../../Components/Navbar';
import Sidebar from "../../Components/Sidebar";
import { SidebarProvider, useSidebar } from "../../Context/SidebarContext";

import "./index.css";

const MainContent = () => {
  const { isOpen } = useSidebar();
  
  return (
    <div className={`main-content ${isOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
      <Outlet />
    </div>
  );
};

const RootLayout = () => {


  return (
    <SidebarProvider>
      <div className="rootLayout">
        <header className="navbar-container">
          <Navbar />
        </header>
        <main className="content-container">
          <Sidebar />
          <MainContent />
        </main>
      </div>
    </SidebarProvider>
  );
};

export default RootLayout;